import React from 'react';

export default function BackToTethrLink(props: { tethrUrl: string | nundefined; linkText: string; }) {
	const tethrUrl = props.tethrUrl;
	if (!tethrUrl)
		return null;

	const link = `${tethrUrl}${tethrUrl.endsWith('/') ? '' : '/'}demoCalls?source=myCalls`;
	return <a href={link} rel="noopener noreferrer">{props.linkText}</a>;
}
